import { CommonModule } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { CookiesService } from "./core/services/cookies.service";
import { LoaderService } from "./core/services/loader.service";
import { LANGUAGES_OPTIONS, DEFAULT_PEOPLE_MATE_LANGUAGE } from "./shared/constants/languages";
import { COOKIES_KEYS } from "./shared/constants/storage-keys";
import { Language } from "./shared/interfaces/language.interface";
import { SharedModule } from "./shared/modules/shared.module";
import { AuthService } from "./core/services/auth.service";

@Component({
    selector: "app-root",
    imports: [SharedModule, CommonModule, RouterOutlet],
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  private translateService = inject(TranslateService);
  private cookiesService = inject(CookiesService);
  private titleService = inject(Title);
  private cd = inject(ChangeDetectorRef);

  // #region declare & init. variables
  langClass: string;
  languages: string[] = LANGUAGES_OPTIONS;
  selectedLang: Language = DEFAULT_PEOPLE_MATE_LANGUAGE;

  loaderService = inject(LoaderService);
  authService = inject(AuthService);
  isLoading = false;
  forceLoading = false;
  showLoader = false;

  constructor() {
    this.handleSettingDefaultLanguage();
    this.langClass = this.translateService.currentLang;

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langClass = event.lang;
    });
    this.setTitle();
  }

  public setTitle() {
    const title = environment.TITLE;
    const favIcon = document.querySelector("#favIcon");
    (favIcon as HTMLLinkElement).href = environment.ICON;
    this.titleService.setTitle(title);
  }

  handleSettingDefaultLanguage() {
    this.translateService.addLangs(this.languages);

    if (this.cookiesService.check(COOKIES_KEYS.LANGUAGE_KEY)) {
      this.selectedLang = this.cookiesService.get(COOKIES_KEYS.LANGUAGE_KEY);
    } else {
      this.cookiesService.set(COOKIES_KEYS.LANGUAGE_KEY, this.selectedLang);
    }
    this.translateService.use(this.selectedLang.code);
  }

  // #endregion

  // #region ngOnInit

  moveScrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  handleKeyboardEvent(event: KeyboardEvent): boolean {
    // Block F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C, Ctrl+U
    if (
      event.key === "F12" ||
      (event.ctrlKey && event.shiftKey && event.key === "I") || // Chrome/Edge/Windows
      (event.ctrlKey && event.shiftKey && event.key === "J") || // Chrome/Windows
      (event.ctrlKey && event.shiftKey && event.key === "C") || // Chrome/Windows
      (event.ctrlKey && event.key === "U") || // View source
      // Mac Command combinations
      (event.metaKey && event.altKey && event.key === "I") || // Safari
      (event.metaKey && event.altKey && event.key === "J") || // Safari
      (event.metaKey && event.altKey && event.key === "C") || // Safari
      // Refresh combinations
      (event.metaKey && event.shiftKey && event.key === "C") || // Hard refresh (Mac)
      (event.ctrlKey && event.shiftKey && event.key === "C") || // Hard refresh (Windows/Linux)
      event.key === "F5" || // Standard refresh
      (event.metaKey && event.key === "C") || // Standard refresh (Mac)
      // Additional devtools shortcuts
      (event.metaKey && event.shiftKey && event.key === "D") || // Chrome DevTools (Mac)
      (event.metaKey && event.shiftKey && event.key === "K") || // Firefox DevTools (Mac)
      (event.metaKey && event.shiftKey && event.key === "I") // Chrome/Edge (Mac)
    ) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    return true;
  }

  onRightClick(event: MouseEvent) {
    event.preventDefault();
    return false;
  }
}
